// extracted by mini-css-extract-plugin
module.exports = {"clients":"clients-module--clients--E0YqF","gallery":"clients-module--gallery--14Z1-"};